var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.575 23.5c6.545 0 11.85-5.26 11.85-11.75S24.12 0 17.575 0c-6.544 0-11.85 5.26-11.85 11.75s5.306 11.75 11.85 11.75",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.575 50c9.706 0 17.575-5.26 17.575-11.75S27.281 26.5 17.575 26.5 0 31.76 0 38.25 7.869 50 17.575 50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.975 5A9.3 9.3 0 0 0 32 5.9a15.23 15.23 0 0 1-2.3 15.45A9.399 9.399 0 1 0 35.975 5",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.975 26.25a20.6 20.6 0 0 0-4.175.425 13.98 13.98 0 0 1 7.075 11.575A12.2 12.2 0 0 1 36.8 45c7.35-.275 13.2-4.35 13.2-9.35s-6.275-9.4-14.025-9.4"
  })));
};
export default SvgUsers;